import { FormFieldNames } from '@/types';
export const fieldsMapping = {
    social_planner: {
        fields: [
            FormFieldNames.TITLE,
            FormFieldNames.DESCRIPTION,
            FormFieldNames.KEYWORDS,
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.CUSTOM_LENGTH_OF_CONTENT,
            FormFieldNames.LENGTH_OF_CONTENT,
        ],
        required: [
            FormFieldNames.TITLE,
            FormFieldNames.DESCRIPTION,
            FormFieldNames.KEYWORDS,
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.LENGTH_OF_CONTENT,
        ],
        optional: [FormFieldNames.CUSTOM_LENGTH_OF_CONTENT],
    },
    blog: {
        fields: [
            FormFieldNames.SUB_TYPE,
            FormFieldNames.TITLE,
            FormFieldNames.DESCRIPTION,
            FormFieldNames.KEYWORDS,
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.CUSTOM_LENGTH_OF_CONTENT,
        ],
        required: [
            FormFieldNames.TITLE,
            FormFieldNames.DESCRIPTION,
            FormFieldNames.SUB_TYPE,
            FormFieldNames.KEYWORDS,
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.LENGTH_OF_CONTENT,
        ],
        optional: [FormFieldNames.CUSTOM_LENGTH_OF_CONTENT],
    },
    funnel: {
        fields: [FormFieldNames.DESCRIPTION, FormFieldNames.ADDITIONAL],
        required: [FormFieldNames.DESCRIPTION],
        optional: [FormFieldNames.TONE, FormFieldNames.NUMBER_OF_VARIATIONS],
    },
    website: {
        fields: [FormFieldNames.DESCRIPTION, FormFieldNames.ADDITIONAL],
        required: [FormFieldNames.DESCRIPTION],
        optional: [FormFieldNames.TONE, FormFieldNames.NUMBER_OF_VARIATIONS],
    },
    email_builder: {
        fields: [
            FormFieldNames.CONTEXT,
            FormFieldNames.TITLE,
            FormFieldNames.DESCRIPTION,
            FormFieldNames.KEYWORDS,
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
        ],
        required: [
            FormFieldNames.TITLE,
            FormFieldNames.DESCRIPTION,
            FormFieldNames.CONTEXT,
            FormFieldNames.KEYWORDS,
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
        ],
        optional: [],
    },
    email_builder_subject: {
        fields: [FormFieldNames.DESCRIPTION, FormFieldNames.ADDITIONAL],
        required: [FormFieldNames.DESCRIPTION],
        optional: [FormFieldNames.TONE, FormFieldNames.NUMBER_OF_VARIATIONS],
    },
    email_builder_cta: {
        fields: [FormFieldNames.DESCRIPTION, FormFieldNames.ADDITIONAL],
        required: [FormFieldNames.DESCRIPTION],
        optional: [FormFieldNames.NUMBER_OF_VARIATIONS],
    },
    email_builder_body: {
        fields: [
            FormFieldNames.CONTEXT,
            FormFieldNames.TITLE,
            FormFieldNames.DESCRIPTION,
            FormFieldNames.KEYWORDS,
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.CUSTOM_LENGTH_OF_CONTENT,
            FormFieldNames.LENGTH_OF_CONTENT,
        ],
        required: [
            FormFieldNames.TITLE,
            FormFieldNames.DESCRIPTION,
            FormFieldNames.CONTEXT,
            FormFieldNames.KEYWORDS,
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.LENGTH_OF_CONTENT,
        ],
        optional: [FormFieldNames.CUSTOM_LENGTH_OF_CONTENT],
    },
    funnel_paragraph: {
        fields: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.ADDITIONAL,
            FormFieldNames.CUSTOM_LENGTH_OF_CONTENT,
            FormFieldNames.LENGTH_OF_CONTENT,
        ],
        required: [FormFieldNames.DESCRIPTION, FormFieldNames.LENGTH_OF_CONTENT],
        optional: [
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.CUSTOM_LENGTH_OF_CONTENT,
        ],
    },
    website_paragraph: {
        fields: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.ADDITIONAL,
            FormFieldNames.CUSTOM_LENGTH_OF_CONTENT,
            FormFieldNames.LENGTH_OF_CONTENT,
        ],
        required: [FormFieldNames.DESCRIPTION, FormFieldNames.LENGTH_OF_CONTENT],
        optional: [
            FormFieldNames.TONE,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.CUSTOM_LENGTH_OF_CONTENT,
        ],
    },
};
